import { css } from '@emotion/react';
import DOMPurify from 'dompurify';
import Markdown from 'react-markdown';

interface Props {
    ctcaFindings: string;
    nonCardiacFindings?: string;
}

export const Findings = (props: Props) => {
    const { ctcaFindings, nonCardiacFindings } = props;

    if (!!nonCardiacFindings) {
        return (
            <>
                <div
                    css={css`
                        flex: 1;
                    `}
                >
                    <h2>CTCA Findings</h2>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ctcaFindings) }} />
                </div>

                <div
                    css={css`
                        flex: 1;
                    `}
                >
                    <h2>Non-Coronary Findings</h2>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(nonCardiacFindings ?? '') }} />
                </div>
            </>
        );
    }

    return (
        <div
            css={css`
                flex: 1;
                max-width: min(60rem, 50%);
                margin: 0 auto;
                text-align: center;
            `}
        >
            <h2>CTCA Findings</h2>
            <div
                css={css`
                    text-align: justify;
                `}
            >
                <Markdown>{ctcaFindings}</Markdown>
            </div>
            {/* <div
                css={css`
                    text-align: justify;
                `}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ctcaFindings ?? '') }}
            /> */}
        </div>
    );
};
